import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import FormStepWrapper from 'components/form/FormStepWrapper';
import { PhoneInputField } from 'components/inputs/PhoneInputField';
import TextInputField from 'components/inputs/TextInputField';
import { Text1, Text1Bold } from 'components/typography/Texts';
import { useBecomeFundraiser } from 'features/my-profile/become-fundraiser/context/BecomeFundraiserProvider';
import ContactSupportButton from 'features/my-profile/become-fundraiser/form/components/ContactSupportButton';

const OrganizationInfo = styled.div`
  margin-bottom: 12px;
`;

const VerifyContactDetails = () => {
  const { t } = useTranslation('myProfile');
  const { formData, errors, setFieldValue } = useBecomeFundraiser();

  const { addressLine1, addressLine2, city, state, zipCode } = formData.organization!;
  const detailsInfo = `${addressLine1} ${addressLine2 || ''}\n${city}, ${state} ${zipCode}`;

  return (
    <FormStepWrapper
      header={t('become-fundraiser.verify-contact-details.header')}
      description={t('become-fundraiser.verify-contact-details.description')}
      isValid={!errors.mobilePhone && !errors.email}>
      <OrganizationInfo>
        <Text1Bold>{formData.organization?.name}</Text1Bold>
        <Text1>{detailsInfo}</Text1>
      </OrganizationInfo>
      <PhoneInputField
        value={formData.mobilePhone || ''}
        onChange={value => setFieldValue('mobilePhone', value)}
        testId={'phone-field'}
        defaultCountry={'US'}
        errorMessage={errors.mobilePhone}
      />
      <TextInputField
        value={formData.email || ''}
        onChange={value => setFieldValue('email', value)}
        placeholder={t('become-fundraiser.verify-contact-details.email-placeholder')}
        errorMessage={errors.email}
      />
      <ContactSupportButton />
    </FormStepWrapper>
  );
};

export default VerifyContactDetails;
